export default __webpack_public_path__ + "static/4a5fb0af34bb4833ea888a3ad9b32907.svg";